import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import ControlQuadrant from "./ControlQuadrant";
import {useBoundStore} from "../../stores/useBoundStore";
import PropTypes from "prop-types";
import {useMeasure} from "react-use";

const Holder = styled.div.attrs(props => ({
  style: {
    gridTemplateColumns: props.xCols,
    gridTemplateRows: props.yRows,
  },
}))`
  display: grid;
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-items: start;
  justify-items: start;
`;

function Control(props) {
  const quad1Settings = useBoundStore((state) => state.quad1)
  const quad2Settings = useBoundStore((state) => state.quad2)
  const quad3Settings = useBoundStore((state) => state.quad3)
  const quad4Settings = useBoundStore((state) => state.quad4)
  const [ref, {width, height}] = useMeasure();
  const [xCols, setXCols] = useState("50% 50%");
  const [yRows, setYRows] = useState("50% 50%");

  useEffect(() => {
    let colWidths = [];
    if (width % 2 === 0) {
      colWidths = [width / 2, width / 2];
    } else {
      colWidths = [Math.floor(width / 2), Math.ceil(width / 2)];
    }
    setXCols(colWidths.join("px ") + "px");
  }, [width, setXCols])

  useEffect(() => {
    let rowHeights = [];
    if (height % 2 === 0) {
      rowHeights = [height / 2, height / 2];
    } else {
      rowHeights = [Math.floor(height / 2), Math.ceil(height / 2)];
    }
    setYRows(rowHeights.join("px ") + "px");
  }, [height, setYRows])

  return (
    <Holder
      ref={ref}
      xCols={xCols}
      yRows={yRows}
      className="control">
      <ControlQuadrant settings={props.customSettings?.quad1 || quad1Settings}
                       customScheme={props.customSettings?.colorScheme} />
      <ControlQuadrant settings={props.customSettings?.quad2 || quad2Settings}
                       customScheme={props.customSettings?.colorScheme} />
      <ControlQuadrant settings={props.customSettings?.quad3 || quad3Settings}
                       customScheme={props.customSettings?.colorScheme} />
      <ControlQuadrant settings={props.customSettings?.quad4 || quad4Settings}
                       customScheme={props.customSettings?.colorScheme} />
    </Holder>
  );
}

Control.propTypes = {
  customSettings: PropTypes.object,
};

export default Control;
